import { InjectionKey } from "@lib/svelte-typed-context";
import { CartQuery } from "@modules/cart/queries/CartQuery";
import { CartService } from "@modules/cart/services/CartService";

export const wishlistPageWidgetContext = Symbol(
    "wishlistPageWidgetContext"
) as InjectionKey<{ cartService: CartService; cartQuery: CartQuery }>;
